<div class="p-col-12 bodyChartPainterro">
    <div class="painterroClass" id="customPainterro"></div>
</div>
